<template>
  <b-row class="px-3">
    <b-col class="pl-0 mb-2" v-for="(item, index) in data" :class="index+1 === data.length ? 'pr-0' : 'pr-2'">
      <stat-tile :label="item.label"
                 :value="item.value"
                 :icon="item.icon"
                 :bg-color="item.bgColor"
                 color="#FFFFFF"
                 css-class="rounded h-100"
                 icon-class="icon-white"
                 :label-class="labelClass"
                 :clickable="item.hasOwnProperty('clickValue')"
                 :to="item.to"
                 :checkbox="checkbox"
                 :checkbox-model="checkboxModel"
                 :checkbox-value="item.checkboxValue"
                 @checkbox:changed="$emit('update:checkboxModel', $event)"
      />
    </b-col>
  </b-row>
</template>

<script>
import StatTile from '@/components/Dashboard/StatTile';
import { cloneDeep } from 'lodash';

export default {
  name: 'BreakdownPanel',
  components: {
    StatTile,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    labelClass: {
      type: String,
    },
    checkbox: {
      type: Boolean,
      default: false,
    },
    checkboxModel: {
      type: Array,
    },
  },
};
</script>

<style scoped>

</style>
